var map = {
	"./ar.svg": "f651",
	"./bo.svg": "4638",
	"./br.svg": "93c7",
	"./ca.svg": "61d5",
	"./ch.svg": "903d",
	"./cl.svg": "5618",
	"./co.svg": "60ef",
	"./de.svg": "7e20",
	"./ec.svg": "269f",
	"./es.svg": "2bcf",
	"./fr.svg": "4b32",
	"./gt.svg": "c80a",
	"./it.svg": "fe62",
	"./mx.svg": "3590",
	"./ni.svg": "3a6b",
	"./nl.svg": "84ab",
	"./pa.svg": "9abc",
	"./pe.svg": "5742",
	"./pr.svg": "292d",
	"./pt.svg": "b96b",
	"./ru.svg": "e643",
	"./sv.svg": "6315",
	"./us.svg": "a6fe",
	"./uy.svg": "2fbc",
	"./ve.svg": "89d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";